module.exports = __webpack_public_path__ + "media/images/icon/white/ico-medal-5a4b58bc0d6622aa8337d774ed39bcde.svg";